import React from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import DropableThumbnail from '../thumbnail/DropableThumbnail';
import _ from 'lodash';
const deepMap = (children, map) => {
  return React.Children.map(children, child => {
    if (!React.isValidElement(child)) {
      return child;
    }

    if (child.props.children) {
      child = React.cloneElement(child, {
        children: deepMap(child.props.children, map),
      });
    }

    return map(child);
  });
};

export default class Form extends React.Component {
  constructor(props) {
    super(props);

    this.fieldRefs = {};

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
    this.onSubmit =  props.onSubmit;
  }

  clearInputData() {
    Object.values(this.fieldRefs).forEach(ref => ref.clearInputData());
  }

  getFormData(alwaysReadFields = []) {
    const data = Object.values(this.fieldRefs)
      .map(component => {        
        if (component && component.getWrappedInstance) return component.getWrappedInstance();
        else return component;})
      .filter(component => !!component)
      .filter(component => {
        return (
          alwaysReadFields.indexOf(component.props.field) !== -1 ||
          alwaysReadFields.indexOf(component.props.id) !== -1 ||
          component.getFieldState().isDirty
        );
      })
      .reduce((fields, component) => {
        const name = component.props.field || component.props.id;
        const value = component.getFieldState().value;
        return { ...fields, [name]: value };
      }, {});
    return data;
  }

  onValueChange(event, field) {
    const isValid = Object.values(this.fieldRefs)
      .map(ref => {
        if (ref && ref.getWrappedInstance) return ref.getWrappedInstance();
        else return ref;
      })
      .filter(ref => !!ref)
      .every(ref => ref.getFieldState().isValid
      );
    this.setState(
      {
        isValid,
        isDirty: true,
        isSubmittable: isValid,
      },
      () => {
        this.notify();
      },
    );
  }

  onValidChange() {
    const isValid = Object.values(this.fieldRefs)
    .map(ref => {
      if (ref && ref.getWrappedInstance) return ref.getWrappedInstance();
      else return ref;
    })
    .filter(ref => !!ref)
    .every(ref => ref.getFieldState().isValid);

    this.setState(
      {
        isValid,
        isSubmittable: isValid && this.state.isDirty,
      },
      () => {
        this.notify();
      },
    );
  }

  notify() {
    const { isValid, isDirty, isSubmittable } = this.state;
    if (this.props.onValid) {
      this.props.onValid(isValid);
    }

    if (this.props.onDirty) {
      this.props.onDirty(isDirty);
    }

    if (this.props.onSubmittable) {
      this.props.onSubmittable(isSubmittable);
    }
  }

  refHandler(id, ref) {
    this.fieldRefs = {
      ...this.fieldRefs,
      [id]: ref,
    };
  }

  prepareField(component) {
    const { isSubmittable } = this.state;
    const _this = this;
    return React.cloneElement(component, {
      key: component.props.id,
      onChange: value => {
        if (component.props.onValueChange) {
          component.props.onValueChange(value.target.value);
        }
        this.onValueChange();
      },
      onKeyUp: e => {
        if (e.key === 'Enter') {
          if (e.target.type !== 'textarea' || (e.target.type === 'textarea' && e.ctrlKey)) {
            if (isSubmittable && _this.onSubmit) {
              _this.onSubmit();
            }
          }
        }
      },
      onValid: this.onValidChange.bind(this),
      ref: this.refHandler.bind(this, component.props.id),
    });
  }

  renderForm(fields) {
    return (
      <Row>
        <Col xs={12} md={12}>
          {deepMap(fields, child => {
            return child.type.name === 'FieldGroup' ? this.prepareField(child) : child;
          })}
        </Col>
      </Row>
    );
  }

  renderFormWithThumbnail(fields) {
    return (
      <Row>
        <Col xs={12} md={4}>
          <DropableThumbnail
            id="image"
            image={this.props.image}
            onChange={this.onValueChange.bind(this)}
            ref={this.refHandler.bind(this, 'image')}
          />
        </Col>
        <Col xs={12} md={8}>
          {deepMap(fields, child => {
            return child.type.name === 'FieldGroup' ? this.prepareField(child) : child;
          })}
        </Col>
      </Row>
    );
  }

  renderErrorMessage(errorMessage) {
    if (!errorMessage) return null;
    return (
      <Alert bsStyle="danger" style={{ 'white-space': 'pre' }}>
        {errorMessage}
      </Alert>
    );
  }

  render() {
    const {
      showThumbnail,
      children,
      errorMessage,
      onFocus,
      onBlur,
    } = this.props;
    const flattenFields = React.Children.toArray(children);
    return (
      <React.Fragment>
        {errorMessage && this.renderErrorMessage(errorMessage)}
        <form
          onFocus={() => onFocus && onFocus()}
          onBlur={() => onBlur && onBlur()}
          onSubmit={e => e.preventDefault()}
        >
          {showThumbnail
            ? this.renderFormWithThumbnail(flattenFields)
            : this.renderForm(flattenFields)}
        </form>
      </React.Fragment>
    );
  }
}

Form.defaultProps = {
  showThumbnail: true,
};



// WEBPACK FOOTER //
// ./src/components/form/Form.js